<template>
    <div>
        <h1 class="contact mt-3 mb-5">Kontakt</h1>
        <div class="row pt-4 pl-2 pr-2">
            <div class="col-12 col-md-4">
                <h4>Adres Kliniki:</h4>
                <img src="../assets/logo.png" alt="Top Medical Clinic" class="img-fluid pt-3 pb-3">
                <address>
                    Unit 1 Colmore House, Frazer Nash Close,<br><br>
                    <h4>Isleworth,TW7 5AG</h4>
                    <small>off 396-402 London Road</small><br><br>
                    Tel: <a href="tel:02088473988">0208 847 3988</a><br>
                    Mob: <a href="tel:07719305019">0771 930 5019</a><br>
                    Fax: 0208 568 997<br>
                    Email: <a href="mailto:hounslow@topmedicalclinic.co.uk">hounslow@topmedicalclinic.co.uk</a>
                </address>
            </div>
            <div class="col-12 col-md-8">
                <h4 class="text-left">Mapa Dojazdu:</h4>
                <div><iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2485.0241986622577!2d-0.3354603553951228!3d51.47607012141792!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48760d011259921b%3A0x2f45ac77b5844ada!2sLondon%20Rd%2C%20Isleworth%20TW7%205AG!5e0!3m2!1spl!2suk!4v1569226247972!5m2!1spl!2suk" width="100%" height="450" frameborder="0" style="border:0;" allowfullscreen=""></iframe></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
h1, h4 {
  font-weight: 400;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
IMG { width: 100px;}
</style>
